import styled from '@emotion/styled';
import { Color, RadioButton } from '@liveoptics/react-ui';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FormError } from '../../form-error/FormError';
import SelectionOption from '../SelectionOption';

const FormContainer = styled.form`
  color: ${Color.coolGray700};
`;

const FormContent = styled.div`
  padding: 26px 26px 0px 26px;
  max-height: 400px;
  overflow: auto;
  > p {
    font: 600 16px/20px Open Sans;
    margin: 0;
  }
`;

const SubFormContent = styled.div`
  padding-left: 36px;
  > div {
    label {
      display: none;
    }
  }
  > div:not(:last-child) {
    margin-bottom: 22px;
  }
`;

const FormActions = styled.div<{ increasePadding: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  vertical-align: bottom;
  margin-top: 32px;
  padding: ${(p) => (p.increasePadding ? '0px 42px 24px 0px' : '0px 24px 24px 0px')};
  a {
    margin-right: 24px;
    padding-bottom: 10px;
  }
`;

const CheckboxGroup = styled.div`
  padding: 24px 0 24px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export interface FormProps {
  selectionOption: SelectionOption;
  error?: string;
  children?: JSX.Element | JSX.Element[];
  renderActions: () => JSX.Element;
  onChange: (option: SelectionOption) => void;
}

const Form = (props: FormProps) => {
  const [scrollVisible, setScrollVisible] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    setScrollVisible(
      contentRef.current != null &&
        (contentRef.current as Element).scrollHeight > (contentRef.current as Element).clientHeight
    );
  }, []);

  const handleChange = useCallback(
    (selectionOption: SelectionOption) => () => {
      props.onChange(selectionOption);
    },
    [props]
  );

  return (
    <FormContainer>
      <FormContent ref={contentRef}>
        <p>Who Owns The Assets In This Project?</p>
        <CheckboxGroup>
          <div>
            <RadioButton
              id="dell"
              type="radio"
              name="verify-owner-selection"
              checked={props.selectionOption === SelectionOption.Dell}
              onChange={handleChange(SelectionOption.Dell)}
            />
            <label htmlFor="dell">Dell Internal Lab</label>
          </div>
          <div>
            <RadioButton
              id="skip"
              type="radio"
              name="verify-owner-selection"
              checked={props.selectionOption === SelectionOption.Skip}
              onChange={handleChange(SelectionOption.Skip)}
            />
            <label htmlFor="skip">Skip - Customer's email unknown</label>
          </div>
          <div>
            <RadioButton
              id="customer"
              type="radio"
              name="verify-owner-selection"
              checked={props.selectionOption === SelectionOption.Customer}
              onChange={handleChange(SelectionOption.Customer)}
            />
            <label htmlFor="customer">I need to assign my customer's email</label>
          </div>
        </CheckboxGroup>
        <SubFormContent>
          {props.error ? <FormError error={props.error} /> : <></>}
          {props.children}
        </SubFormContent>
      </FormContent>
      <FormActions increasePadding={scrollVisible}>{props.renderActions()}</FormActions>
    </FormContainer>
  );
};

export default Form;
